import React from "react";

export default function Logo({ ...rest }) {
  return (
    <svg
      viewBox="0 0 363 455"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1_23)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M198.984 108.175C220.384 108.175 237.84 91.2248 237.84 70.4465C237.84 49.6682 220.384 32.743 198.984 32.743C177.579 32.743 160.153 49.664 160.153 70.4465C160.153 91.2248 177.579 108.175 198.984 108.175Z"
          fill="#FF6158"
        />
        <path
          d="M250.668 318.232C248.47 318.232 246.237 317.818 244.082 316.949L192.742 296.17C183.997 292.631 179.863 282.877 183.507 274.385C187.15 265.893 197.19 261.873 205.931 265.412L257.275 286.191C266.016 289.73 270.154 299.484 266.511 307.976C263.762 314.37 257.387 318.232 250.668 318.232Z"
          fill="#FF6158"
        />
        <path
          d="M257.533 265.835C255.335 265.835 253.102 265.421 250.947 264.552L180.582 236.084C171.841 232.548 167.703 222.794 171.342 214.298C174.981 205.802 185.021 201.786 193.766 205.322L264.132 233.789C272.877 237.325 277.011 247.079 273.372 255.575C270.627 261.977 264.252 265.835 257.533 265.835Z"
          fill="#FF6158"
        />
        <path
          d="M258.587 213.099C256.393 213.099 254.161 212.685 252.006 211.816L211.527 195.442C202.782 191.907 198.648 182.153 202.288 173.657C205.927 165.161 215.967 161.141 224.708 164.68L265.186 181.054C273.931 184.589 278.069 194.343 274.426 202.839C271.685 209.242 265.306 213.099 258.587 213.099Z"
          fill="#FF6158"
        />
        <path
          d="M17.1376 455C13.4985 455 9.82921 453.88 6.71914 451.561C-0.795769 445.965 -2.2239 435.505 3.54025 428.204L141.841 252.888C147.601 245.583 158.368 244.204 165.883 249.799C173.398 255.395 174.826 265.855 169.062 273.156L30.7608 448.472C27.3841 452.752 22.291 455 17.1376 455Z"
          fill="#FF6158"
        />
        <path
          d="M218.105 196.725C214.461 196.725 210.792 195.605 207.682 193.286C200.167 187.686 198.747 177.23 204.507 169.929L231.177 136.137C236.941 128.836 247.704 127.453 255.219 133.053C262.734 138.653 264.158 149.109 258.393 156.41L231.723 190.202C228.347 194.481 223.254 196.725 218.105 196.725Z"
          fill="#FF6158"
        />
        <path
          d="M180.44 159.235C178.242 159.235 176.005 158.821 173.845 157.948L103.505 129.455C94.7645 125.915 90.6306 116.157 94.2784 107.665C97.9219 99.1734 107.966 95.1573 116.707 98.7012L187.047 127.194C195.788 130.734 199.922 140.492 196.274 148.984C193.529 155.382 187.154 159.235 180.44 159.235Z"
          fill="#FF6158"
        />
        <path
          d="M282.822 113.186C279.183 113.186 275.514 112.066 272.399 109.746C264.885 104.146 263.461 93.6905 269.221 86.3897L332.239 6.52352C338.003 -0.777304 348.766 -2.16058 356.281 3.43519C363.796 9.03514 365.22 19.4912 359.455 26.792L296.445 106.662C293.069 110.942 287.971 113.186 282.822 113.186Z"
          fill="#FF6158"
        />
        <path
          d="M127.255 235.503C123.615 235.503 119.95 234.383 116.84 232.068C109.321 226.472 107.897 216.016 113.657 208.711L140.301 174.919C146.061 167.614 156.824 166.231 164.343 171.822C171.862 177.418 173.286 187.874 167.531 195.179L140.878 228.971C137.505 233.255 132.408 235.503 127.255 235.503Z"
          fill="#FF6158"
        />
      </g>
    </svg>
  );
}
